module.exports = __webpack_public_path__ + "img/00007.1d6eaed2.webp";